import Surnames from "../models/surnames";

export default class SurnameFactory {
  static createFromJson(json: any): Surnames {
    return new Surnames(json);
  }

  static createFromJsonArray(jsonArray: any[]): Surnames[] {
    const jsonData: Surnames[] = [];
    jsonArray.forEach((item) => {
      jsonData.push(SurnameFactory.createFromJson(item));
    });

    return jsonData;
  }
}
